module.exports = __webpack_public_path__ + "static/et-book-display-italic-old-style-figures-43eb7a3417177f8f0fff766082379da5.woff";